import { LeafSelectOption } from "./select-option.component.js";
import "lit/decorators.js";
import "../leaf-element.js";
import "lit";
import "../../utilities/events.js";
customElements.define("leaf-select-option", LeafSelectOption);
export {
  LeafSelectOption
};
//# sourceMappingURL=select-option.js.map
